import React, { Component } from 'react'
import { Icon, Select } from 'antd'
import { agency } from '@services/api'
import { inject, observer } from 'mobx-react';

const { Option } = Select;

@inject((store: any) => {
    const { authStore } = store
    return { authStore }
})
@observer
export default class extends Component {
    constructor(props) {
        super(props)

        this.state = {
            agencyName: '',
            agencyType: '',
            license: '',
            updatedBy: ''
        }
    }

    verify = (agencyName, agencyType, license) => {
        let borderError = '3px solid red'
        let haveToFill = 'יש להכניס '
        let haveToPick = 'יש לבחור '
        let err = ''
        let licenseErr = 'רישיון לא תקין - '

        if (!agencyName) {
            document.getElementById('agencyName').style.border = borderError
            err += haveToFill + 'שם סוכן/ות'
        }

        if (!agencyType) {
            document.getElementById('type').style.border = borderError
            err !== '' ? err += '\n' : null
            err += haveToPick + 'סוג סוכן/ות'
        }

        if (!license) {
            document.getElementById('license').style.border = borderError
            err !== '' ? err += '\n' : null
            err += haveToFill + 'רישיון'
        }

        if (license && license.match(/^[0-9]+$/) == null) {
            document.getElementById('license').style.border = borderError            
            err !== '' ? err += '\n' : null
            err += licenseErr + 'יש להכניס מספרים בלבד'
        }

        if (license && license.match(/^[0-9]+$/) != null && license.length < 9) {
            document.getElementById('license').style.border = borderError            
            err !== '' ? err += '\n' : null
            err += licenseErr + 'יש להכניס 9 ספרות'
        }

        if (err !== '') {
            alert(err)
            return false
        } else {       
            return true
        } 
    }

    clearBorders = () => {
        document.getElementById('agencyName').style.border = ''
        document.getElementById('type').style.border = ''
        document.getElementById('license').style.border = ''
    }

    success = (licenseType, agencyName, license) => {
        let borderValid = '3px solid green'

        this.setState({ agencyName: '', agencyType: '', license: '' })
        
        document.getElementById('agencyName').style.border = borderValid            
        document.getElementById('type').style.border = borderValid            
        document.getElementById('license').style.border = borderValid   
        
        alert(`${licenseType} ${agencyName} ${license} - נוסף בהצלחה`)
    }

    errorHandler = (err) => {
        let errStatus = err.response.status
        let agencyName = err.response.data
        
        if (errStatus === 409) alert(`סוכן/ות כבר קיים במערכת בשם:\n${agencyName}`)
        else if (errStatus === 400) alert('רישיון לא תקין')
        else alert('שגיאה בהעלאת הנתונים')
    }
    
    submit = (agencyName, agencyType, license, fullName) => {
        let licenseType = agencyType === 'AGENT' ? 'סוכן ביטוח' : agencyType === 'AGENCY' ? 'סוכנות ביטוח' : ''
        let data = {
            agencyName: agencyName,
            agencyType: agencyType,
            licenseType: licenseType,
            license: license,
            updatedBy: fullName
        }
        try {
            agency.addAgency({ data }).then(res => {
                this.success(licenseType, agencyName, license)
            }).catch(err => {
                this.errorHandler(err)
            })
        } catch (error) {
            console.log(error);
        }
     }

    handleSubmit = () => {
        let { agencyName, agencyType, license } = this.state
        const { authStore: { fullName } } = this.props
        
        this.verify(agencyName, agencyType, license) 
                ? this.submit(agencyName, agencyType, license, fullName) 
                : null
    }

    render() {
        const { agencyName, agencyType, license } = this.state
        
        return (
            <>
                <div>
                    <input
                        id='agencyName'
                        value={agencyName}
                        style={{ width: '15%',
                                 border: '' }}
                        placeholder="שם הסוכן/ות"
                        onChange={name => { this.setState({ agencyName: name.target.value })
                                  document.getElementById('agencyName').style.border === '3px solid green' 
                                  ? this.clearBorders() 
                                  : document.getElementById('agencyName').style.border = ''
                                  }}
                    />
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flex: 1,
                        alignItems: 'center',
                    }}
                >   
                    <Select
                        id="type"
                        style={{ width: '15%' }}
                        defaultValue={agencyType}
                        value={agencyType}
                        onChange={type => {this.setState({ agencyType: type })
                                           document.getElementById('type').style.border === '3px solid green' 
                                           ? this.clearBorders() 
                                           : document.getElementById('type').style.border = ''}}                        
                                        >
                        <Option value={''} disabled={true}>בחר סוג</Option>
                        <Option value={'AGENT'}>
                            סוכן
                        </Option>
                        <Option value={'AGENCY'}>
                            סוכנות
                        </Option>
                    </Select>
                </div>
                
                <div>
                    <input
                        id='license'
                        style={{ width: '15%',
                                 border: '' }}
                        value={license}
                        placeholder="רישיון"
                        type='text'
                        maxLength='9'
                        onChange={license => {this.setState({ license: license.target.value.replace(/[^0-9]/g, "") })
                                              document.getElementById('license').style.border === '3px solid green' 
                                              ? this.clearBorders() 
                                              : document.getElementById('license').style.border = ''}
                    />
                </div>

                <div>
                    <Icon type='check' onClick={this.handleSubmit}></Icon>
                </div>
            </>    
        )
    }
}
